import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	VehicleColorSearchDto,
	VehicleColorsFilters,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseSearchableNewComponent } from '../../../../../../../shared/base-classes/base-searchable-new.component';
import { SearchableFieldComponent } from '../../../../../../../shared/components/searchable-field/searchable-field.component';
import { SelectItem } from '../../../../../../../shared/models/select-item.type';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../../../../shared/tokens/searchable-strategy.token';
import { VehicleColorSearchStrategy } from '../../../../config/color-searchable-strategy';

@Component({
	selector: 'app-color-searchable',
	template: `
		<app-searchable-field
			[label]="label()"
			[formControl]="searchableId"
			[filters]="filters()" />
	`,
	imports: [ReactiveFormsModule, SearchableFieldComponent],
	host: {
		class: 'w-full',
	},
	providers: [
		{
			provide: SEARCHABLE_STRATEGY_TOKEN,
			useClass: VehicleColorSearchStrategy,
		},
	],
})
export class ColorSaerchableComponent extends BaseSearchableNewComponent<
	SelectItem<VehicleColorSearchDto>,
	VehicleColorsFilters
> {}
